import React from "react";

export default function Services() {
  return (
    <div className="our-services">
      <div className="container">
        {/* Section Header */}
        <div className="row section-row align-items-center">
          <div className="col-lg-7 col-md-7">
            <div className="section-title">
              <h3
                className="wow fadeInUp"
                style={{ visibility: "visible", animationName: "fadeInUp" }}
              >
                Our Services
              </h3>

              <h2 className="text-anime-style-3" style={{ perspective: "400px" }}>
                What we can offer today
              </h2>
            </div>
          </div>

          <div className="col-lg-5 col-md-5">
            <div className="section-btn">
              <a
                href="/services"
                className="btn-default wow fadeInUp"
                data-wow-delay="0.25s"
              >
                View All Services
              </a>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row">
          {/* Service Item */}
          <ServiceItem
            delay="0.25s"
            title="Digital Marketing Strategy"
            desc="Drive growth with data-driven digital marketing strategies that increase visibility, engagement, and qualified leads."
            img="/assets/images/Digital_Services.png"
          />

          <ServiceItem
            delay="0.5s"
            title="Website & Software Development"
            desc="Custom websites and scalable software solutions designed for performance, security, and seamless user experience."
            img="/assets/images/website_development.png"
          />

          <ServiceItem
            delay="0.75s"
            title="Brand Building"
            desc="Create a strong, trusted brand identity that resonates with your audience and differentiates you in the healthcare market."
            img="/assets/images/brand_building.png"
          />

          <ServiceItem
            delay="1s"
            title="Data Analytics"
            desc="Transform raw data into actionable insights to improve decision-making, efficiency, and business outcomes."
            img="/assets/images/data_analytics.png"
          />

          <ServiceItem
            delay="1.25s"
            title="Social Media Management"
            desc="Build and manage a powerful social media presence to engage audiences, grow communities, and strengthen brand trust."
            img="/assets/images/social_media_management.png"
          />

          <ServiceItem
            delay="1.5s"
            title="Healthtech Specific Solutions"
            desc="Tailored technology solutions designed specifically for healthcare providers, startups, and healthtech enterprises."
            img="/assets/images/specific.png"
          />
        </div>
      </div>
    </div>
  );
}

/* Reusable Service Card */
function ServiceItem({ title, desc, img, delay }) {
  return (
    <div className="col-lg-4 col-md-6">
      <div
        className="service-item wow fadeInUp"
        data-wow-delay={delay}
      >
        <div className="service-content">
          <div className="service-content-title">
            <h4>{title}</h4>
          </div>
          <p>{desc}</p>
        </div>

        <div className="service-image">
          <figure className="image-anime">
            <img src={img} alt={title} loading="lazy" />
          </figure>
        </div>
      </div>
    </div>
  );
}
